<template>
  <Modal v-model="isLoginSessionModalOpen" :hideModalHeader="true">
    <section>
      <div
        data-controller="tabs"
        data-tabs-active-tab="-mb-px border-l border-t border-r rounded-t"
        data-tabs-index="0"
      >
        <div>
          <ul
            class="flex items-center cursor-pointer text-center text-sm font-bold mb-5"
          >
            <li
              @click="didClickTab(1)"
              :class="
                this.data.tabIndex == 1
                  ? ['bg-white', 'text-gray-dark ']
                  : ['bg-gray-200', 'text-gray-500']
              "
              class="p-3 w-2/4 hover:text-black uppercase rounded-tl-lg border-b -my-2"
            >
              Login
            </li>
            <li
              @click="didClickTab(2)"
              :class="
                this.data.tabIndex == 2
                  ? ['bg-white', 'text-gray-dark ']
                  : ['bg-gray-200', 'text-gray-500']
              "
              class="p-3 w-2/4 hover:text-black uppercase rounded-tr-lg border-b -my-2"
            >
              New to Fitclass
            </li>
          </ul>
        </div>

        <div data-tabs-target="panel">
          <p class="text-center text-gray-dark text-sm font-bold uppercase">
            {{ data.title }}
          </p>
          <form @submit.prevent="handleLogin">
            <div class="ml-10 mr-10 mt-4">
              <FormInput
                :type="'text'"
                v-model="$v.email.$model"
                :classStr="{ 'border-red-500': $v.email.$error }"
                >Email</FormInput
              >
              <div v-if="$v.email.$error">
                <small class="text-red-500" v-if="!$v.email.required">
                  Email field is required.
                </small>
                <small class="text-red-500" v-if="$v.email.email">
                  Accepts valid email addresses.
                </small>
              </div>
            </div>
            <div v-if="hasAccount">
              <div class="relative ml-10 mr-10 mt-4">
                <FormInput
                  :type="'password'"
                  v-model="$v.password.$model"
                  :classStr="{ 'border-red-500': $v.password.$error }"
                  >Password</FormInput
                >
                <div v-if="$v.password.$error">
                  <small class="text-red-500" v-if="$v.password.required">
                    Password field is required.
                  </small>
                </div>
              </div>
            </div>

            <div v-else>
              <div class="relative ml-10 mr-10 mt-4">
                <FormInput
                  :type="'name'"
                  v-model="$v.name.$model"
                  :classStr="{ 'border-red-500': $v.name.$error }"
                  >Name</FormInput
                >
                <div v-if="$v.name.$error">
                  <small class="text-red-500" v-if="!$v.name.required">
                    Name field is required.
                  </small>
                </div>
              </div>
            </div>

            <div class="relative ml-10 mr-10 justify-center mt-4 mb-4">
              <Button>
                {{ data.buttonType }}
              </Button>
            </div>

            <small
              class="text-sm flex justify-center right-0 text-gray-dark hover:text-green-light capitalize"
            >
              <router-link
                v-if="data.tabIndex == 1"
                :to="{ name: 'ResetPassword' }"
              >
                Forgot password
              </router-link>
              <router-link v-else :to="{ name: 'Register' }">
                Create a new account
              </router-link>
            </small>
            <div class="text-gray-dark separator text-sm font-bold mt-3">
              OR
            </div>
          </form>
        </div>

        <div
          class="hidden py-4 px-4 border-l border-r"
          data-tabs-target="panel"
        >
          Tab panel 2
        </div>
      </div>
      <div class="flex justify-center mb-4">
        <!-- <GoogleLogin @onLogin="onGoogleLogin" :isGuest="isGuest" /> -->
      </div>
    </section>
  </Modal>
</template>

<script>
import { FormInput, Modal, Button } from "@/components/t-components";
import { required, email, minLength } from "vuelidate/lib/validators";
// import GoogleLogin from "@/components/google-login/GoogleLogin";
import { mapActions, mapGetters } from "vuex";
import firebase from "firebase/app";
import "firebase/messaging";
import store from "@/store";
import * as Cookies from "js-cookie";

export default {
  name: "LoginSessionModal",
  components: {
    Modal,
    FormInput,
    Button,
    // GoogleLogin,
  },
  data() {
    return {
      NATIVE: 1,
      GUEST: 2,
      data: {
        title: "LOGIN WITH EMAIL",
        tabIndex: 1,
        inputType: "Password",
        buttonType: "Log in",
      },
      email: null,
      password: null,
      name: null,
      firebase_token: null,
      isGuest: false,
    };
  },
  validations: {
    email: {
      required,
      email,
    },
    password: {
      required,
    },
    name: {
      minLength: minLength(2),
      required,
    },
  },
  props: {
    isLoginSessionModalOpen: {
      type: Boolean,
      required: true,
    },
    handleLoginSessionModal: {
      type: Function,
      required: true,
    },
    handleLoginSuccess: {
      type: Function,
      required: true,
    },
  },
  computed: {
    ...mapGetters(["isValidSession", "error", "guestData"]),

    hasAccount() {
      if (this.data.tabIndex == 1) {
        return true;
      }
      return false;
    },
  },
  methods: {
    ...mapActions(["login", "guestNativeLogin", "validateSession"]),

    didClickTab(chosenIndex) {
      this.data.tabIndex = chosenIndex;
      if (chosenIndex == 1) {
        this.data.title = "Login with email";
        this.data.inputType = "Password";
        this.data.buttonType = "Log in";
      } else {
        this.data.title = "Continue as guest";
        this.data.inputType = "Name";
        this.data.buttonType = "Join";
        this.isGuest = true;
      }
    },

    // onGoogleLogin(user) {
    //   if (user.user_type == this.TRAINER) {
    //     const error = {
    //       title: "INVALID_CREDENTIAL",
    //       text:
    //         "You are not a valid attendee . Please join with an attendee account.",
    //     };
    //     store.commit("setError", error);
    //     Cookies.remove("token");
    //     localStorage.removeItem("user");
    //     localStorage.removeItem("details");
    //   } else {
    //     this.handleLoginSuccess();
    //   }
    // },
    async handleLogin() {
      this.$v.email.$touch();
      this.$v.name.$touch();
      this.$v.password.$touch();
      if (
        (this.$v.email.$invalid &&
          this.$v.password.$invalid &&
          this.data.tabIndex == 1) ||
        (this.$v.email.$invalid &&
          this.$v.name.$invalid &&
          this.data.tabIndex == 2)
      ) {
        console.log("invalid");
      } else {
        // Guest login
        if (this.data.tabIndex == this.GUEST) {
          const request = {
            email: this.email,
            name: this.name,
            consent: 1, //TODO: Add consent button
          };
          await this.guestNativeLogin(request);
        } else {
          // User login
          const data = {
            email: this.email,
            password: this.password,
            firebase_token: this.firebase_token,
          };
          await this.login(data);
        }

        if (this.guestData.statusCode == 394) {
          this.$router.push({
            name: "Register",
            query: { email: this.email, name: this.name },
          });
          return;
        }

        //After either login type successfull, check if session valid.
        let loggedUser = this.getUser();
        if (loggedUser.user_type == 2) {
          const error = {
            title: "INVALID_CREDENTIAL",
            text:
              "You are not a valid attendee . Please join with an attendee account.",
          };
          store.commit("setError", error);
          Cookies.remove("token");
          localStorage.removeItem("user");
          localStorage.removeItem("details");
          return;
        }

        if (
          (loggedUser.user_type == 0 && this.data.tabIndex == this.GUEST) ||
          (loggedUser.user_type == 1 && this.data.tabIndex == this.NATIVE)
        ) {
          try {
            await this.validateSession(this.$route.params.id);
            if (this.isValidSession.statusCode != 319) {
              this.handleLoginSessionModal(false);
              this.handleLoginSuccess();
              return;
            }
          } catch (e) {
            console.log("Session not valid.");
            console.log(e);
          }
        } else {
          console.log("ACCESS DENIED");
        }
      }
    },
  },
  created() {
    this.handleNotificationPermission();

    if (firebase.messaging.isSupported()) {
      firebase.app();
      var messaging = firebase.messaging();

      messaging
        .requestPermission()
        .then(() => messaging.getToken())
        .then((token) => {
          this.firebase_token = token;
        })
        .catch(function (e) {
          console.log("Unable to get permission to notify.");
        });
    }
  },
};
</script>

<style scoped>
.separator {
  display: flex;
  align-items: center;
  text-align: center;
}

.separator::before,
.separator::after {
  content: "";
  flex: 1;
  border-bottom: 1px solid rgb(156, 163, 175);
}

.separator:not(:empty)::before {
  margin-right: 1em;
}

.separator:not(:empty)::after {
  margin-left: 1em;
}

.tab-shadow-right {
  box-shadow: 10px 0 5px -2px #888;
}
</style>